export default __webpack_public_path__ + "static/media/changePassword.734954b9.svg";